import React from 'react';
import { ArrowDown } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Segunda Vida</h1>
          <p className="hero-subtitle">Transformando Material Reciclado en Algo Hermoso</p>
          <p className="hero-description">
            Carteras únicas hechas a mano con anillas de lata recicladas de nuestro restaurante de ceviches.
            Cada pieza cuenta una historia de sostenibilidad y empodera a mujeres de áreas rurales.
          </p>
          <div className="hero-message">
            <span className="message-highlight">"Recicla lo que puedas reciclar y crea"</span>
          </div>
          <div className="hero-buttons">
            <button className="cta-button primary">Ver Colección</button>
            <button className="cta-button secondary">Nuestra Historia</button>
          </div>
        </div>
        <div className="hero-image">
          <div className="image-placeholder">
            <p>Imagen de carteras hechas a mano</p>
            <small>Aquí irán las fotos de tus productos</small>
          </div>
        </div>
      </div>
      <div className="scroll-indicator">
        <ArrowDown size={24} />
      </div>
    </section>
  );
};

export default Hero;